import { Box, SxProps, Theme, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';

type BaseCardProps = PropsWithChildren & {
    sx?: SxProps<Theme>;
};

const Card = ({ children, sx }: BaseCardProps) => {
    return (
        <Box
            sx={{
                background: 'white',
                display: 'inline-block',
                borderRadius: '0.625rem',
                padding: '0.625rem',
                boxShadow: '0 0.125rem 0.375rem 0 #0000001A',
                ...sx
            }}>
            {children}
        </Box>
    );
};

const Title = ({ children, sx }: BaseCardProps) => {
    return (
        <Typography
            variant={'h3'}
            sx={{ color: 'secondary.main', fontSize: 20, paddingY: '0.313rem', ...sx }}>
            {children}
        </Typography>
    );
};

const SubTitle = ({ children, sx }: BaseCardProps) => {
    return (
        <Typography sx={{ fontSize: 13, color: 'cardSubtitle.main', ...sx }}>{children}</Typography>
    );
};

const Body = ({ children }: PropsWithChildren) => {
    return <Box>{children}</Box>;
};

const Footer = ({ children }: PropsWithChildren) => {
    return <Box>{children}</Box>;
};

Card.Title = Title;
Card.SubTitle = SubTitle;
Card.Body = Body;
Card.Footer = Footer;

export default Card;
